import { CheckCircle2, XCircle, Star, MinusCircle, AlertTriangle, MessageCircleQuestion, Info } from "lucide-react";

export const STATUS = {
  preferred: {
    key: "preferred",
    label: "Heel graag",
    Icon: Star,
    tone: "emerald",
    badge: "bg-emerald-100 text-emerald-800 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800",
    dot: "bg-emerald-500",
    ring: "border-emerald-500",
    solid: "bg-emerald-600 border-emerald-600 text-white",
    soft: "border-emerald-200 bg-emerald-50 text-emerald-800 hover:bg-emerald-100",
  },
  available: {
    key: "available",
    label: "Beschikbaar",
    Icon: CheckCircle2,
    tone: "sky",
    badge: "bg-sky-100 text-sky-800 border-sky-300 dark:bg-sky-950/60 dark:text-sky-300 dark:border-sky-800",
    dot: "bg-sky-500",
    ring: "border-sky-500",
    solid: "bg-sky-600 border-sky-600 text-white",
    soft: "border-sky-200 bg-sky-50 text-sky-800 hover:bg-sky-100",
  },
  reluctant: {
    key: "reluctant",
    label: "Liever niet, bespreekbaar",
    Icon: MessageCircleQuestion,
    tone: "amber",
    badge: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800",
    dot: "bg-amber-500",
    ring: "border-amber-500",
    solid: "bg-amber-500 border-amber-500 text-white",
    soft: "border-amber-200 bg-amber-50 text-amber-900 hover:bg-amber-100",
  },
  unavailable: {
    key: "unavailable",
    label: "Niet beschikbaar",
    Icon: XCircle,
    tone: "rose",
    badge: "bg-rose-100 text-rose-800 border-rose-300 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-800",
    dot: "bg-rose-500",
    ring: "border-rose-500",
    solid: "bg-rose-600 border-rose-600 text-white",
    soft: "border-rose-200 bg-rose-50 text-rose-800 hover:bg-rose-100",
  },
  none: {
    key: "none",
    label: "Geen voorkeur",
    Icon: MinusCircle,
    tone: "slate",
    badge: "bg-slate-100 text-slate-600 border-slate-300 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700",
    dot: "bg-slate-400",
    ring: "border-slate-300",
    solid: "bg-slate-500 border-slate-500 text-white",
    soft: "border-slate-200 bg-white text-slate-700 hover:bg-slate-50",
  },
};

export const STATUS_ORDER = ["preferred", "available", "reluctant", "unavailable"];

export const WARN = {
  error: { Icon: XCircle, cls: "text-rose-700 bg-rose-50 border-rose-300 dark:bg-rose-950/50 dark:text-rose-300" },
  warning: { Icon: AlertTriangle, cls: "text-amber-800 bg-amber-50 border-amber-300 dark:bg-amber-950/50 dark:text-amber-300" },
  info: { Icon: Info, cls: "text-sky-800 bg-sky-50 border-sky-300 dark:bg-sky-950/50 dark:text-sky-300" },
};

export const SWAP_STATUS = {
  requested: { label: "Aangevraagd", cls: "bg-sky-100 text-sky-700" },
  accepted: { label: "Geaccepteerd (wacht op planner)", cls: "bg-amber-100 text-amber-800" },
  rejected: { label: "Geweigerd", cls: "bg-rose-100 text-rose-700" },
  withdrawn: { label: "Ingetrokken", cls: "bg-slate-100 text-slate-600" },
  approved: { label: "Goedgekeurd", cls: "bg-red-100 text-red-800" },
  planner_declined: { label: "Afgewezen door planner", cls: "bg-rose-100 text-rose-700" },
};
